(function () {
  'use strict';

  // Filtri nativi di Shopify: filtra il server, qui basta inviare il modulo.
  var form = document.querySelector('[data-native-filters]');
  if (form) {
    form.addEventListener('change', function () { form.submit(); });
    var ordina = document.querySelector('[data-native-sort]');
    if (ordina) {
      ordina.addEventListener('change', function () {
        form.querySelector('[name="sort_by"]').value = ordina.value;
        form.submit();
      });
    }
    return;
  }

  var root = document.querySelector('[data-grid]');
  if (!root) return;

  var cells = Array.prototype.slice.call(root.querySelectorAll('.collection__cell'));
  var countEl = document.querySelector('[data-count]');
  var emptyEl = document.querySelector('[data-empty]');
  var priceOut = document.querySelector('[data-price-out]');
  var template = countEl ? countEl.textContent.trim() : '';

  function selected(name) {
    return Array.prototype.slice
      .call(document.querySelectorAll('[data-filter="' + name + '"]:checked'))
      .map(function (input) { return input.value.toLowerCase(); });
  }

  var rangeMax = document.querySelector('[data-filter="price-max"]');
  var campoMin = document.querySelector('[data-filter="price-min-eur"]');
  var campoMax = document.querySelector('[data-filter="price-max-eur"]');
  var tetto = rangeMax ? parseInt(rangeMax.max, 10) : Infinity;

  function inCentesimi(campo, ripiego) {
    if (!campo || campo.value === '') return ripiego;
    var euro = parseFloat(campo.value.replace(',', '.'));
    if (isNaN(euro) || euro < 0) return ripiego;
    return Math.round(euro * 100);
  }

  function mostraTetto(centesimi) {
    if (!priceOut) return;
    priceOut.textContent =
      'fino a ' +
      (centesimi / 100).toLocaleString('it-IT', { minimumFractionDigits: 2 }) + ' \u20AC';
  }

  function apply() {
    var brands = selected('brand');
    var tags = selected('tag');
    var minimo = inCentesimi(campoMin, 0);
    var massimo = inCentesimi(campoMax, tetto);
    if (massimo < minimo) massimo = minimo;
    var visible = 0;

    cells.forEach(function (cell) {
      var brand = (cell.getAttribute('data-brand') || '').toLowerCase();
      var cellTags = (cell.getAttribute('data-tags') || '').toLowerCase();
      var price = parseInt(cell.getAttribute('data-price'), 10);

      var ok =
        (!brands.length || brands.indexOf(brand) > -1) &&
        (!tags.length || tags.some(function (t) { return cellTags.indexOf(t) > -1; })) &&
        price >= minimo && price <= massimo;

      cell.hidden = !ok;
      if (ok) visible++;
    });

    if (countEl) countEl.textContent = template.replace(/\d+/, visible);
    if (emptyEl) emptyEl.hidden = visible > 0;
    mostraTetto(massimo);
  }

  // Cursore e campo "A" restano allineati: si muove uno, si aggiorna l'altro.
  if (rangeMax) {
    rangeMax.addEventListener('input', function () {
      if (campoMax) campoMax.value = Math.round(rangeMax.value / 100);
      apply();
    });
  }
  [campoMin, campoMax].forEach(function (campo) {
    if (!campo) return;
    campo.addEventListener('input', function () {
      if (campo === campoMax && rangeMax) {
        var c = inCentesimi(campoMax, tetto);
        rangeMax.value = Math.min(c, tetto);
      }
      apply();
    });
  });

  // Brand e genere: senza questo le caselle cambiavano stato ma la griglia no.
  document.querySelectorAll('input[type="checkbox"][data-filter]').forEach(function (box) {
    box.addEventListener('change', apply);
  });

  function sort(mode) {
    var ordinate = cells.slice();
    if (mode === 'price-asc' || mode === 'price-desc') {
      ordinate.sort(function (a, b) {
        var d = parseInt(a.getAttribute('data-price'), 10) - parseInt(b.getAttribute('data-price'), 10);
        return mode === 'price-asc' ? d : -d;
      });
    } else if (mode === 'title-asc') {
      ordinate.sort(function (a, b) {
        return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '', 'it');
      });
    }
    ordinate.forEach(function (cell) { root.appendChild(cell); });
  }

  var reset = document.querySelector('[data-filter-reset]');
  if (reset) {
    reset.addEventListener('click', function () {
      document.querySelectorAll('[data-filter]:checked').forEach(function (i) { i.checked = false; });
      if (rangeMax) rangeMax.value = rangeMax.max;
      if (campoMin) campoMin.value = '';
      if (campoMax) campoMax.value = Math.round(tetto / 100);
      apply();
    });
  }

  var sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) sortSelect.addEventListener('change', function () { sort(sortSelect.value); });

  var query = document.querySelector('[data-search-input]');
  if (query) {
    query.addEventListener('input', function () {
      var needle = query.value.trim().toLowerCase();
      var visible = 0;
      cells.forEach(function (cell) {
        var ok = !needle || cell.dataset.title.toLowerCase().indexOf(needle) > -1;
        cell.hidden = !ok;
        if (ok) visible++;
      });
      if (countEl) countEl.textContent = template.replace(/\d+/, visible);
      if (emptyEl) emptyEl.hidden = visible > 0;
    });
  }
  // Primo passaggio: allinea conteggio ed etichetta del prezzo al caricamento.
  apply();

})();
